<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view class="page"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {},
};
</script>

<style lang="">
.fade-enter-active,
.fade-leave-active {
  will-change: transform;
  transition: all 300ms;
  transform-origin: center;
}

.fade-enter {
  opacity: 0;
  transform: translateX(-10px) scale(1);
}
.fade-leave-active {
  opacity: 0;
  transform: translateX(10px) scale(1);
}
body {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue